import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_delivery_call } from "function/FnBodyStep";
import { fn_orderDetailBaemin, fn_connectFailBaemin } from "function/FnBodyLayer";
import { fn_orderEndDetail } from "function/FnBodyDetail";
import { fn_bridge_order_detail_baemin } from "function/FnPosBridge";
import { baerminUseYn, baeminUsePosNo } from "utils/Utils";
import { MobileOrderFg, StepCd } from "types";

@observer
class BaeminOrderListButtonViewCase extends Component {
  render() {
    const { rootStore, order, searchStore } = this.props;

    let checkCallBack = order.mobileOrderFg === "29" || order.mobileOrderFg === "30" ? true : false;
    let checkHooking = order.mobileOrderFg === "08" || order.mobileOrderFg === "22" ? true : false;
    let detailType = "";

    if (
      (searchStore.getCurrStepType === "all" && order.stepType === "READY") ||
      searchStore.getCurrStepType === "ready"
    ) {
      detailType = "ready";
    } else if (
      (searchStore.getCurrStepType === "all" && order.stepType === "COOKING") ||
      searchStore.getCurrStepType === "cooking"
    ) {
      detailType = "cooking";
    } else if (
      (searchStore.getCurrStepType === "all" && order.stepType === "DELIVERY") ||
      searchStore.getCurrStepType === "delivery"
    ) {
      if ((order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500") {
        detailType = "cooking";
      } else {
        detailType = "delivery";
      }
    }

    function onClickActionBtn() {
      if (detailType === "ready") {
        baerminUseYn(rootStore)
          ? baeminUsePosNo(rootStore)
            ? fn_bridge_order_detail_baemin(rootStore, order)
            : fn_orderDetailBaemin(rootStore)
          : fn_connectFailBaemin(rootStore, "baemin_connect_fail_accept", order); //수락
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          fn_delivery_call(rootStore, order.mobileOrderNo, "riderCallDetail Button");
        } else if (order.orderType === "PICKUP") {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(rootStore, "baemin_connect_fail_pickupCall", order); //픽업호출
        } else {
          fn_bridge_order_detail_baemin(rootStore, order);
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(
                rootStore,
                checkCallBack ? "baemin_connect_fail_ready" : "baemin_connect_fail_complete",
                order
              ); //준비완료,배달완료
        } else {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(rootStore, "baemin_connect_fail_pickupCall", order); //픽업호출
        }
      } else if (order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED) {
        fn_orderEndDetail(rootStore, order.mobileOrderNo, "endOrderView");
      }
    }

    function btnTypeTxt() {
      let txt = "";
      if (detailType === "ready") {
        txt = "주문접수";
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          checkCallBack ? (txt = "준비완료") : (txt = "배달요청");
        } else if (order.orderType === "PICKUP") {
          txt = "호출";
        } else {
          checkHooking ? (txt = "픽업완료") : (txt = "호출");
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          if (order.mobileOrderFg === MobileOrderFg.BAEMIN_STORE) {
            txt = "배달완료";
          } else {
            txt = "준비완료";
          }
        } else {
          txt = "호출";
        }
      }

      return txt;
    }

    function btnEnd() {
      let end_txt = "";
      if (order.stepCd === StepCd.ORDER_COMPLETED) {
        end_txt = "완료주문";
      } else if (order.stepCd === StepCd.ORDER_CANCELLED) {
        end_txt = "취소주문";
      }
      return end_txt;
    }

    function btnClass() {
      let color = "";

      // 완료/취소 상태를 가장 먼저 체크하여 리턴함
      if (order.stepCd === StepCd.ORDER_COMPLETED) {
        return "complete end";
      } else if (order.stepCd === StepCd.ORDER_CANCELLED) {
        return "complete cancel";
      }

      if (detailType === "ready") {
        color = "s";
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          checkCallBack ? (color = "complete") : (color = "s");
        } else if (order.orderType === "PICKUP") {
          color = "s";
        } else {
          checkHooking ? (color = "complete") : (color = "s");
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          order.mobileOrderFg === MobileOrderFg.BAEMIN_ONE && order.partnerEtcInfo !== "COOK_COMPLETED"
            ? (color = "s")
            : (color = "complete");
        } else {
          color = "s";
        }
      }

      return color;
    }

    return (
      <>
        <span className={order.stepCd === StepCd.ORDER_COMPLETED ? "btn_cancel show" : "hide"}></span>
        <button type="button" className={btnClass()} onClick={() => onClickActionBtn()}>
          {order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED ? (
            <span className="btn_end">{btnEnd()}</span>
          ) : (
            <span className={order.partnerEtcInfo === "COOK_COMPLETED" ? "checkTxt" : ""}>{btnTypeTxt()}</span>
          )}
          {order.partnerEtcInfo === "COOK_COMPLETED" &&
          !(order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED) ? (
            <span className="checkIco"></span>
          ) : null}
        </button>
      </>
    );
  }
}

export default BaeminOrderListButtonViewCase;
